/// <amd-module name="Artifacts/Upack/UpackProtocol" />
3; /// <amd-module name="Artifacts/Upack/UpackProtocol" />
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import {
  createBadgeCommand,
  createDeleteCommand,
  createGetLinkCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
} from "Artifacts/Upack/commands";
import { logoContributionId } from "Artifacts/Upack/components/Logo";
import { UpackAttributes } from "Artifacts/Upack/components/UpackPackageAttributes";
import { UpackOverview } from "Artifacts/Upack/components/UpackPackageOverview";
import { UpackModule } from "Artifacts/Upack/redux/";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export class UpackProtocol implements IProtocol {
  public readonly id = Protocol.UPack;
  public readonly name = "UPack";
  // No public repo, so no status page for UPack
  public readonly statusUrl = undefined;

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createPromoteCommand(pageContext, versions),
      createDeleteCommand(pageContext, versions, feed),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createBadgeCommand(pageContext, versions, feed),
      createGetLinkCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];
    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return UpackOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return UpackAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return UpackModule;
  }

  getUpstreamOverrideStatus(
    _pageContext: IVssPageContext,
    _packageName: string,
    _feed?: IFeed,
  ): Promise<boolean> {
    throw new Error("Universal packages does not support Upstream Override");
  }

  public getUpstreamingProperties(pageContext: IVssPageContext): IUpstreamingProperties {
    const isUpackSameCollectionUpstreamAvailable = isFeatureFlagEnabled(
      pageContext,
      "Packaging.Feed.UPackSameCollectionUpstreams",
      false,
    );
    const isUpackCrossCollectionUpstreamAvailable = isFeatureFlagEnabled(
      pageContext,
      "Packaging.Feed.UPackCrossCollectionUpstreams",
      false,
    );

    return {
      isPublicUpstreamsSupported: false,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: isUpackSameCollectionUpstreamAvailable,
      isAadUpstreamsSupported: isUpackCrossCollectionUpstreamAvailable,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }
}

ProtocolService.registerProtocol(new UpackProtocol());
